import React from "react";
import { Navigate } from "react-router-dom";
import { useFeatureFlag, useFeatureFlagsLoading } from "../context/FeatureFlagsContext";
import { FeatureFlags } from "../types/featureFlags";

interface FeatureFlagRouteProps {
    flag: keyof FeatureFlags;
    redirectTo: string;
    children: React.ReactNode;
}

/**
 * Renders children only while `flag` is on; otherwise redirects. Waits for the
 * first /config fetch to settle before deciding, so a direct load of a flagged
 * URL isn't bounced by the fail-closed default before flags have resolved.
 */
export const FeatureFlagRoute: React.FC<FeatureFlagRouteProps> = ({ flag, redirectTo, children }) => {
    const enabled = useFeatureFlag(flag);
    const loading = useFeatureFlagsLoading();
    if (loading) return null;
    return enabled ? <>{children}</> : <Navigate to={redirectTo} replace />;
};
